<template>
	<div
		@click="smoothScrollTo(target_selector, scroll_to_bottom)"
		class="scroll_button"
	>
		{{ scroll_to_bottom == (true || '1') ? '&darr;' : '&uarr;'  }}
	</div>
</template>

<script>
export default {
	data() {
		return {
			hello: 'World',
		};
	},

	props: {
		target_selector: {
			type: String,
			required: true,
		},
		scroll_to_bottom: {
			default: false,
		},
	},

	computed: {},

	watch: {},

	methods: {
		smoothScrollTo(target_selector, scroll_to_bottom) {
			this.$nextTick(() => {
				const element = document.querySelector(target_selector);
				if (element) {
					const elementRect = element.getBoundingClientRect();
					// const scrollTop =
					// 	window.pageYOffset || document.documentElement.scrollTop;
					const offset =
						scroll_to_bottom === (true || '1')
							? elementRect.bottom - 150
							: elementRect.top - 150;
					window.scrollTo({
						top: offset,
						behavior: 'smooth',
					});
				}
			});
		},
	},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.scroll_button {
	border: 1px solid var(--duco-blue);
	width: 50px;
	height: 50px;
	display: flex;
	justify-content: center;
	align-items: center;
	color: var(--duco-blue);
	font-size: 30px;
	background: white;

	.page_header & {
		position: absolute;
		bottom: -28px;
		left: 17px;
		z-index: 10;

		@media (max-width: $mobile-xl) {
      left: 0;
			bottom: -52px;
    }
	}

	&:hover {
		cursor: pointer;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/ScrollButton.vue